export default __webpack_public_path__ + "static/media/elk.0af20fe3.svg";